<template>
  <div class="modal is-active">
    <div class="modal-background" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Delete Redaction
        </p>
        <button
          id="modal-close-btn"
          type="button"
          class="delete"
          aria-label="close"
          @click="$emit('close')"
        />
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-12">
            This will delete the {{ type }} redaction.
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          id="modal-delete-btn"
          type="button"
          class="button is-danger"
          :class="isDeleting ? 'is-loading' : ''"
          :disabled="isDeleting"
          @click="deleteRedaction"
        >
          Delete
        </button>
        <button
          id="modal-cancel-btn"
          type="button"
          class="button is-dark"
          @click="$emit('close')"
        >
          Cancel
        </button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DeleteRedaction',
  props: {
    type: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      isDeleting: false,
    };
  },
  methods: {
    async deleteRedaction () {
      this.isDeleting = true;
      let request = await this.$store.dispatch('filing/deleteRedaction', this.type);
      if (request) {
        await this.$store.dispatch('filing/fetchFiling');
        this.$success(`${this.type} redaction deleted successfully.`);
        this.$emit('close');
        this.isDeleting = false;
      } else {
        this.$warning(`There was an issue deleting the ${this.type} redaction.`);
      }
      this.isDeleting = false;
    },
  },
};
</script>